import { FC, createContext, useContext, useState } from "react";

interface LoaderProviderProps {
  children: React.ReactNode;
}

export const LoaderContext = createContext({
  isLoading: false,
  setIsLoading: (_value: boolean) => {},
});

const LoaderProvider: FC<LoaderProviderProps> = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false);
  return (
    <LoaderContext.Provider value={{ isLoading, setIsLoading }}>
      {children}
    </LoaderContext.Provider>
  );
};

export function useLoader() {
  const context = useContext(LoaderContext);
  if (!context) {
    throw new Error("useLoading must be used within LoadingProvider");
  }
  return context;
}

export default LoaderProvider;
